String.prototype.parseHashtag = function () {
  return this.replace(/[#]+[A-Za-z0-9-_]+/g, function (t) {
    var tag = t.replace('#', '');
    return '<a href="https://www.instagram.com/explore/tags/' + tag + '" target="_blank">#' + tag + '</a>';
  });
};


String.prototype.parseAts = function () {
  return this.replace(/[@]+[A-Za-z0-9-_]+/g, function (t) {
    var at = t.replace('@', '');
    return '<a href="https://www.instagram.com/' + at + '" target="_blank">@' + at + '</a>';
  });
};


const instagramFormat = {
  instaLink(linkUrl) {
    const eString = linkUrl.match(new RegExp('<div class="insta-link">' + '(.*)' + '</div>'));
    window.open(eString[1], '_blank');
  },
  title(title) {
    const instaCaptionFull = title.match(new RegExp('<div class="insta-caption">' + '(.*)' + '</div>'));
    let instaCaptionText = instaCaptionFull[1];
    instaCaptionText = instaCaptionText.parseHashtag();
    instaCaptionText = instaCaptionText.parseAts();
    return {
      headline: 'Instagram',
      hash_tag: instaCaptionText
    };
  }
};

export default instagramFormat;



// WEBPACK FOOTER //
// ./src/scripts/instagram-format.js